import { render, staticRenderFns } from "./OperatorBasePermissionGroup.vue?vue&type=template&id=46684cdd&scoped=true&"
import script from "./OperatorBasePermissionGroup.vue?vue&type=script&lang=js&"
export * from "./OperatorBasePermissionGroup.vue?vue&type=script&lang=js&"
import style0 from "./OperatorBasePermissionGroup.vue?vue&type=style&index=0&id=46684cdd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46684cdd",
  null
  
)

export default component.exports